import React from 'react';
import { useTranslation } from 'react-i18next';
import { useBridgeState } from '@digitaz/bridge-sdk-client';
import {
  getReversedLangDefinition,
  makeUrlWithLang
} from '../../utils/helpers';
import { BackHistoryStorage } from '../../utils/helpers/BackHistoryStorage';

interface ChangeLangProps {
  icon?: React.ReactNode;
}

export const ChangeLang: React.FC<ChangeLangProps> = ({ icon }) => {
  const { t, i18n } = useTranslation();
  const { isWebView } = useBridgeState();

  if (isWebView) return null;

  const { language } = i18n;

  const handleClick = () => {
    const { pathname, host, protocol, search } = window.location;
    const newLocation = makeUrlWithLang({
      protocol: protocol.substring(0, protocol.length - 1),
      host,
      path: `${pathname}${search}`,
      lang: getReversedLangDefinition(language)
    });
    BackHistoryStorage.setHistoryBoundaryReload();
    window.location.replace(newLocation);
  };

  return (
    <button onClick={handleClick} data-cy="lang-switcher">
      {icon && <i>{icon}</i>}
      {t('main_menu.lang', { lng: getReversedLangDefinition(language) })}
    </button>
  );
};
